<template>
    <section content padding>
        <div class="d-block align-center">
            <h1 class="size-40">{{ $common.config.lang === 'cn' ? '合作伙伴' : 'Partners' }}</h1>
        </div>
        <br/>
        <Row class="plr-sm">
            <Col :xs="8" :sm="6" :md="4" :lg="3" v-for="(item, index) in partner" :key="index">
                <div class="d-block m-xs">
                    <div class="photo-view rectangle">
                        <img :preview="new Date().getTime()" :src="item.logo"/>
                    </div>
                </div>
            </Col>
        </Row>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                partner: []
            }
        },
        async created() {
            await this.getPartner();
        },
        mounted() {
        },
        methods: {
            async getPartner(){
                let res = await this.$api.getHttp('/product/partner');
                this.partner = [] = res.data.data;
                console.log('this.getPartner---------->', this.partner);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Partner.vue